import { render, staticRenderFns } from "./IndagineEpidemiologicaMalattieTrasmissioneSessualeEditComponent.vue?vue&type=template&id=6b128d11"
import script from "./IndagineEpidemiologicaMalattieTrasmissioneSessualeEditComponent.vue?vue&type=script&lang=js"
export * from "./IndagineEpidemiologicaMalattieTrasmissioneSessualeEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports